import { frontendURL } from '../../../../helper/URLHelper';
import { FEATURE_FLAGS } from '../../../../featureFlags';

import TeamsIndex from './Index.vue';
import SettingsWrapper from '../SettingsWrapper.vue';

// R2-9-6 (phase 9.3): creating and editing a team is a drawer over the list. `new` and `:teamId/edit` open the
// list with the drawer; the old wizard steps (agents, finish) lead to the same drawer or back to the list, so
// links to them keep working.
const meta = {
  featureFlag: FEATURE_FLAGS.TEAM_MANAGEMENT,
  permissions: ['administrator'],
  keepAliveKey: 'teams',
};

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/teams'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'settings_teams_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'settings_teams_list',
          component: TeamsIndex,
          meta,
        },
        {
          path: 'new',
          name: 'settings_teams_new',
          component: TeamsIndex,
          meta,
        },
        {
          path: 'new/:teamId/agents',
          name: 'settings_teams_add_agents',
          meta,
          redirect: to => ({ name: 'settings_teams_edit', params: to.params }),
        },
        {
          path: 'new/:teamId/finish',
          name: 'settings_teams_finish',
          meta,
          redirect: to => ({ name: 'settings_teams_list', params: to.params }),
        },
        {
          path: ':teamId/edit',
          name: 'settings_teams_edit',
          component: TeamsIndex,
          meta,
        },
        {
          path: ':teamId/edit/agents',
          name: 'settings_teams_edit_members',
          meta,
          redirect: to => ({ name: 'settings_teams_edit', params: to.params }),
        },
        {
          path: ':teamId/edit/finish',
          name: 'settings_teams_edit_finish',
          meta,
          redirect: to => ({ name: 'settings_teams_list', params: to.params }),
        },
      ],
    },
  ],
};
